import React from "react";
import { Box, Button, Flex, useColorMode } from "@chakra-ui/react";
import { getCurrentColor } from "../../constants";
import { SmallCloseIcon } from "@chakra-ui/icons";
import { useLocation } from "react-router-dom";
import useSelectedFilter from "../../hooks/useFilter";
import { transformFilterName } from "../../utils/transformFilterName";

const SelectedFilters = () => {
  const location = useLocation();
  const {
    AddOrUpdateFilter,
    selectedFilters,
    ClearFilter,
    ApplyFilter,
    openStickyFilter,
  } = useSelectedFilter();
  const { colorMode } = useColorMode();

  const filterEntries = selectedFilters? Object.entries(selectedFilters) : [];

  return filterEntries.some(([key, values]) => values.length > 0) &&
    openStickyFilter ? (
    <Box
      position="fixed"
      bottom={{ base: "60px", lg: "0px" }}
      zIndex={1000}
      width={{ base: "100%", lg: "auto" }}
      display={"flex"}
      justifyContent={"center"}
      p="10px 20px"
    >
      <Box
        maxWidth={{ base: "100%", lg: "750px", xl: "900px" }}
        minWidth={{ base: "100%", lg: "750px", xl: "900px" }}
        borderRadius={"6px"}
        bg={getCurrentColor(colorMode, "whiteC.100", "grayC.1700")}
        p="10px"
        boxShadow={getCurrentColor(
          colorMode,
          "0px 4px 14px 0px rgba(183, 183, 183, 0.9), 0px 20px 40px 0px rgba(183, 183, 183, 0.9)",
          "0px 4px 14px 0px rgba(183, 183, 183, 0.1), 0px 20px 40px 0px rgba(183, 183, 183, 0.08)"
        )}
        border={"1px solid"}
        borderColor={getCurrentColor(colorMode, "blackC.600", "grayC.2400")}
      >
        <Flex
          flexDirection={"row"}
          flexWrap={"wrap"}
          gap="10px"
          color={getCurrentColor(colorMode, "blackC.300", "grayC.1600")}
          borderColor={getCurrentColor(colorMode, "grayC.400", "grayC.1900")}
          borderRadius={"0px 0px 6px 6px"}
          maxHeight={"200px"}
          overflowY={"auto"}
        >
          {filterEntries.map(([key, values]) => {
            if (values.length === 0) return null;
            const data = transformFilterName(location.pathname, key, {
              title: key,
              value: values.map((item) => item.value),
              flag: values.map((item) => item.flag || item.value),
            });

            return (
              <React.Fragment key={key}>
                {data.value.map((item, i) => (
                  <Flex
                    key={item}
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    borderRadius={"100px"}
                    bg={getCurrentColor(colorMode, "grayC.400", "grayC.1900")}
                    px="10px"
                    py="4px"
                    cursor={"pointer"}
                    onClick={() => {
                      AddOrUpdateFilter(
                        data.query,
                        data.flag[i] || item,
                        "remove"
                      );
                    }}
                  >
                    <Flex
                      gap={"3px"}
                      fontSize={"sm"}
                      fontWeight={"400"}
                      display={"inline"}
                      flexWrap={"wrap"}
                      textTransform={"capitalize"}
                      wordBreak={"break-word"}
                    >
                      {item}
                    </Flex>
                    <SmallCloseIcon
                      cursor={"pointer"}
                      right={0}
                      top={"4px"}
                      color={getCurrentColor(
                        colorMode,
                        "blackC.200",
                        "grayC.1600"
                      )}
                    />
                  </Flex>
                ))}
              </React.Fragment>
            );
          })}
        </Flex>
        <Flex gap={"10px"} mt={"10px"}>
          <Button
            p={0}
            width={"100%"}
            onClick={() => ClearFilter()}
            color={getCurrentColor(colorMode, "blackC.200", "grayC.1600")}
            _hover={{ textDecoration: "blackC.100" }}
          >
            Clear All
          </Button>
          <Button
            p={0}
            width={"100%"}
            onClick={() => ApplyFilter()}
            bg={"blueC.400"}
            _hover={{ bg: "blueC.200" }}
            color={"whiteC.100"}
          >
            Apply
          </Button>
        </Flex>
      </Box>
    </Box>
  ) : null;
};

export default SelectedFilters;
